import { sendGTMEvent } from '@next/third-parties/google'

/**
 * Push one prescription event to GTM.
 *
 * Do NOT also push to `window.dataLayer` here. `sendGTMEvent` already does
 */
export const sendPrescriptionGAEvent = (
	payload: Record<string, unknown>,
): void => {
	if (typeof window === 'undefined') return
	try {
		sendGTMEvent(payload)
		if (process.env.NODE_ENV === 'development') {
			// eslint-disable-next-line no-console
			console.log('[prescription GA]', payload)
		}
	} catch (err) {
		if (process.env.NODE_ENV === 'development') {
			// eslint-disable-next-line no-console
			console.warn('[prescription GA] push failed', err, payload)
		}
	}
}
